export const PopupType = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
}